<template>
  <div class="position-r box">
    <!--banner-->
    <div class="index-banner" :style="{ backgroundImage: 'url(' + topBg.advUrl + ')' }" @click="goToUrl">
      <div class="f24 fw">欢迎使用</div>
      <div class="f24 fw"><span class="color-09">陪一会</span>共享轮椅</div>
      <div class="pt5 flex-fs">
        <div class="mr8 photo-icon">
          <img :src="headPhoto" alt="" class="head-img" />
        </div>
        <span>{{ userName }}</span>
      </div>
    </div>
    <div class="flexJC p15" style="margin-top: -80px">
      <div class="content-box" v-show="isMz == true">
        <div class="flexJC alignItem text-over">
          <!--<div class="flex-fs fw">-->
          <!--<i class="icon-con icon_lb"></i>-->
          <!--<span class="f16 color-3 mt-3">{{filterFun(cabinetInfo&&cabinetInfo.cabinet.placeName)}}</span>-->
          <!--</div>-->
          <div class="f16 color-9">
            <p>租用时间为以下时间段内开放</p>
            <p class="mt10" v-for="item in timerList">
              {{ item.startTime }}-{{ item.endTime }}
            </p>
          </div>
          <p class="pt10" v-show="timerList && timerList.length > 0 && timerList[0].overMoney">
            超时费用为：<span class="f18 color-09">{{
              timerList && timerList.length > 0
                ? timerList[0].overMoney
                  ? timerList[0].overMoney
                  : 0
                : 0
            }}</span>元
          </p>
          <div class="flex mt36">
            <button class="btn-lx btn-width btn-lx-width" @click="tautologyFun">
              重试
            </button>
          </div>
        </div>
      </div>

      <div class="content-box" v-show="isMz == false">
        <div class="flexJC alignItem text-over">
          <div class="flex-fs fw">
            <i class="icon-con icon_lb"></i>
            <span class="f16 color-3 text-over mt-3">{{
              filterFun(cabinetInfo && cabinetInfo.cabinet.placeName)
            }}</span>
          </div>
          <div class="pt18">
            <div class="noNormal" v-show="isNormal !== 1">
              <img src="../../static/images/icon_noNarmal.png" alt="" />
            </div>
            <div class="f16 color-9 pt10" v-show="isNormal !== 1">
              设备不在线
            </div>
            <div class="f16 color-9 pt10" v-show="isNormal == 1 && tag == true">
              <p>请麻烦帮忙关闭柜门再继续</p>
              <p class="mt5">谢谢您的合作</p>
            </div>
          </div>
        </div>
        <div class="flex mt36" :class="
            isNormal == 3 || isNormal == 5 ? 'flexJC-sb' : 'flexJC alignItem'
          ">
          <a href="tel:400-688-1003" class="btn-lx btn-lx-width mr10" v-if="isNormal == 3 || isNormal == 5">联系客服</a>
          <button class="btn-lx btn-width btn-lx-width" @click="nextFun">
            重试
          </button>
        </div>
      </div>
    </div>
    <div class="p15">
      <div class="banner">
        <mt-swipe :auto="8000">
          <mt-swipe-item>
            <div class="cabinet-box flexJC alignItem cabinet-content" @click="goToUrl">
              <div class="fw f20">
                每小时<span class="color-09">{{
                  cabinetInfo && cabinetInfo.cabinet.chargeMoney
                }}</span>元<span class="ml10">押金归还即退</span>
              </div>
              <div class="f14">
                预收金额<span class="f14 color-09">{{
                  cabinetInfo && cabinetInfo.cabinet.depositMoney
                    ? cabinetInfo.cabinet.depositMoney
                    : 0
                }}</span>元
                <span>{{
                    isZfb == 1 ? "微信支付分550分以上" : "芝麻分600以上支付宝"
                  }}扫码免押</span>
              </div>
            </div>
          </mt-swipe-item>
          <mt-swipe-item v-for="item in bannerList" :key="item.advNo">
            <a class="displsy-block banner-a" @click="goToNewUrl(item.outerUrl)"><img :src="item.advUrl" alt="" class="border-radius" /></a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>
    <!--<div class="p15">-->
    <!--<a href="tel:400-688-1003" class="btn-con btn-color btn-width" v-if="isNormal == 3 || isNormal == 5">联系客服</a>-->
    <!--<button class="btn-con btn-color btn-width mb10" @click="nextFun">重试</button>-->
    <!--</div>-->
    <!--弹框-->
    <div class="shade" v-show="isLoading">
      <div class="flexJC alignItem showLoading">
        <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
  </div>
</template>

<script>
import wxServ from "../service/wxServ";
import cache from "../service/cacheServ";
import userServ from "../service/userServ";
import mintUi from "../lib/mint-ui";
import cabinetServ from "../service/cabinetServ";
import zfbServ from "../service/zfbServ";
import log from '../lib/log'
export default {
  data() {
    return {
      headPhoto: "/static/images/touxiang@2x.png",
      userName: "",
      isLoading: false,
      isNormal: null,
      tag: false,
      qrCode: null,
      bedNo: null,
      wxId: null,
      cabinetInfo: null,
      bannerList: [],
      isBackBed: null,
      timerList: [],
      isMz: null,
      isZfb: 1,
      topBg: {
        advUrl: "../../static/images/header-logo.png",
        outerUrl: null,
      },
    };
  },
  created() {
    let qrCode = this.$route.query.qrcode;
    let bedNo = this.$route.query.bedNo;
    console.log("qrCode:" + this.$route.query.qrcode);
    console.log(userServ.IsWeixinOrAlipay());
    this.qrCode = qrCode;
    this.bedNo = bedNo;
    if (userServ.IsWeixinOrAlipay() == "WeiXIN") {
      this.isZfb = 1;
      let userInfo = cache.get("user");
      if (userInfo && userInfo.openId) {
        this.userName = userInfo.customerName;
        this.headPhoto = userInfo.headImgUrl
          ? userInfo.headImgUrl
          : "/static/images/touxiang@2x.png";
        this.wxId = userInfo.openId;
        this.getIsBedFun(userInfo.openId);
        this.getBannerList("HOME");
        this.getBannerList("HOMETOP");
      } else {
        wxServ.getCode();
      }
    } else if (userServ.IsWeixinOrAlipay() == "Alipay") {
      this.isZfb = 2;
      let userInfo = cache.get("user");
      if (userInfo && userInfo.openId) {
        this.userName = userInfo.customerName;
        this.headPhoto = userInfo.headImgUrl
          ? userInfo.headImgUrl
          : "/static/images/touxiang@2x.png";
        this.wxId = userInfo.openId;
        this.getIsBedFun(userInfo.openId);
        this.getBannerList("HOME");
        this.getBannerList("HOMETOP");
      } else {
        zfbServ.getAuthCode();
      }
    } else {
      mintUi.Toast({
        message: "请用微信/支付宝扫码，谢谢",
        position: "bottom",
      });
    }
  },
  methods: {
    // 获取设备状态（微信）
    getCabinetSta(qrCode) {
      this.isLoading = true;
      var bedNo = this.bedNo;
      cabinetServ.getCabinetStatus(qrCode).then((res) => {
        this.isLoading = false;
        if (res.code === "200") {
          if (!res.data) {
          } else {
            this.cabinetInfo = res.data;
            cache.set("cabinetInfo", res.data, true);
            if (res.data.status === "2") {
              // 设备正常
              this.isNormal = 1;
              let doorList = res.data.doorStatus;
              doorList = [1, 1, 1, 1, 1, 1, 1, 1];
              let newList = doorList.filter((item) => item != 1); // 过滤掉当其中有一个门打开时
              console.log(newList);
              if (newList.length > 0) {
                this.tag = true;
              } else {
                this.tag = false;
                this.$router.push({
                  path: "/Index",
                  query: { qrcode: qrCode, bedNo: bedNo },
                });
              }
            } else if (res.data.status === "3") {
              // 设备离线
              this.isNormal = 2;
            } else if (res.data.status === "null") {
              // 设备不在线
              this.isNormal = 5;
            } else {
              this.isNormal = 3;
            }
          }
        } else {
          this.isNormal = 4;
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    nextFun() {
      this.getCabinetSta(this.qrCode);
    },
    goToUrl() {
      if (this.topBg.outerUrl) {
        window.location.href = this.topBg.outerUrl;
      } else {
        window.location.href = "http://www.aigehui028.com/";
      }
    },
    // 获取设备状态（支付宝）
    getZFBCabinetSta(qrCode) {
      let that = this;
      this.isLoading = true;
      cabinetServ.getCabinetStatus(qrCode).then((res) => {
        this.isLoading = false;
        if (res.code === "200") {
          if (!res.data) {
          } else {
            this.cabinetInfo = res.data;
            cache.set("cabinetInfo", res.data, true);
            if (res.data.status === "2") {
              // 设备正常
              this.isNormal = 1;
              let doorList = res.data.doorStatus;
              let newList = doorList.filter((item) => item != 1); // 过滤掉当其中有一个门打开时
              console.log(newList);
              if (newList.length > 0) {
                this.tag = true;
              } else {
                this.tag = false;
                this.$router.push({
                  path: "/alipayIndex",
                  query: { qrcode: qrCode, bedNo: that.bedNo },
                });
              }
            } else if (res.data.status === "3") {
              // 设备离线
              this.isNormal = 2;
            } else if (res.data.status === "null") {
              // 设备不在线
              this.isNormal = 5;
            } else {
              this.isNormal = 3;
            }
          }
        } else {
          this.isNormal = 4;
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    filterFun: function (value) {
      if (value && value.length > 13) {
        value = value.substring(0, 13) + "...";
      }
      return value;
    },
    getBannerList(position) {
      wxServ.getBanner(position).then((res) => {
        if (res.code === "200") {
          if (position == "HOME") {
            this.bannerList = res.data;
          } else if (position == "HOMETOP") {
            if (res.data && res.data.length > 0) {
              this.topBg = res.data[0];
            }
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToNewUrl(url) {
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },
    // 查询是租借还是归还(微信)
    getIsBedFun(id) {
      this.isLoading = true;
      cabinetServ.getCabinetIsZorF(id).then((res) => {
        this.isLoading = false;
        if (res.code === "200") {
          if (res.data && res.data.length > 0) {
            // 归还
            this.isBackBed = true;
            this.isMz = false;
            if (userServ.IsWeixinOrAlipay() == "WeiXIN") {
              this.getCabinetSta(this.qrCode);
            } else if (userServ.IsWeixinOrAlipay() == "Alipay") {
              this.getZFBCabinetSta(this.qrCode);
            }
          } else {
            // 租借
            this.isBackBed = false;
            this.getTimeList(this.qrCode);
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    //获取租借时间段
    getTimeList(qrCode) {
      this.isLoading = true;
      cabinetServ.getOrderTimeList(qrCode).then((res) => {
        this.isLoading = false;
        if (res.code === "200") {
          this.timerList = res.data.timerList;
          var list = res.data.timerList;
          console.log("list", list);
          if (res.data.timerList.length > 0) {
            var newTime = new Date();

            var nowTimes = this.getTimesTamp(
              res.data.nowDate.replace(/-/g, "/")
            );
            console.log("开始时间", res.data.nowDate.replace(/-/g, "/"));
            var yymmdd = this.formatDate(newTime, "yyyy/MM/dd");
            console.log(yymmdd);
            var newList = [],
              iteml = {};
            list.forEach((item) => {
              iteml["startTime"] = this.getTimesTamp(
                yymmdd + " " + item.startTime + ":00"
              );
              console.log(new Date(iteml["startTime"]).toLocaleString());
              iteml["endTime"] = this.getTimesTamp(
                yymmdd + " " + item.endTime + ":00"
              );
              console.log(new Date(iteml["endTime"]).toLocaleString());
              if (item.startTime >= item.endTime) {
                iteml["endTime"] =
                  this.getTimesTamp(yymmdd + " " + item.endTime + ":00") +
                  24 * 60 * 60 * 1000;
              }
              console.log(new Date(iteml["endTime"]).toLocaleString());
              newList.push(iteml);
            });
            console.log(newList);
            if (newList.length > 0) {
              newList.forEach((item) => {
                // if(item.startTime>=nowTimes && nowTimes<=item.endTime){
                this.isMz = false;
                if (userServ.IsWeixinOrAlipay() == "WeiXIN") {
                  this.getCabinetSta(qrCode);
                } else if (userServ.IsWeixinOrAlipay() == "Alipay") {
                  this.getZFBCabinetSta(qrCode);
                }
                // } else {
                //     this.isMz = true
                // }
              });
            }
          } else {
            this.isMz = false;
            if (userServ.IsWeixinOrAlipay() == "WeiXIN") {
              this.getCabinetSta(qrCode);
            } else if (userServ.IsWeixinOrAlipay() == "Alipay") {
              this.getZFBCabinetSta(qrCode);
            }
          }
        }
      });
    },
    formatDate(datetime, fmt = "yyyy/MM/dd hh:mm:ss") {
      let date = new Date();
      date.setTime(Date.parse(datetime));
      const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        "S+": date.getMilliseconds(), // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
        );
      }
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
          ); //eslint-disable-line
        }
      }
      return fmt;
    },
    // 时间戳
    getTimesTamp(time) {
      return new Date(time).getTime();
    },
    tautologyFun() {
      this.getTimeList(this.qrCode);
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
@import "../less/_var.less";
@import "../less/index.less";
.index-banner {
  padding: 26px 25px 0 25px;
  text-align: left;
  color: #fff;
  background-size: 100% 100%;
}
.pt5 {
  padding-top: 5px;
}
.banner {
  height: 120px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.loadingImg {
  width: 100px;
  height: 100px;
}
.loading-con {
  width: 70%;
  margin-left: -35%;
}
.photo-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
.photo-icon img {
  width: 100%;
  height: 100%;
}
.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}
.icon_lb {
  background: url("../../static/images/icon_position.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 16px;
  margin: 0 5px 0 0;
}
.icon-fy {
  background: url("../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.mt-3 {
  margin-top: -2px;
}
.icon-sb {
  background: url("../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon_loading {
  width: 60px;
  height: 60px;
}

.head-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/status.vue